export const MAX_TEXT_LENGTH_TO_SHOW = 80;

export const START_SEARCH = 'handleStartSearch';
